export { default as Pagination } from './Pagination';
export { default as PaginationBehaviour } from './PaginationBehaviour';
//# sourceMappingURL=index.js.map